// extracted by mini-css-extract-plugin
export var card = "personCard-module--card--24HNd";
export var personImage = "personCard-module--personImage--3Ptaq";
export var arrow = "personCard-module--arrow--18cCl";
export var close = "personCard-module--close--3LCFe";